import { useEditTestamentaryEntitySplitScreenModalContext } from './contexts/editTestamentaryEntitySplitScreenModal.context';

export function EditTestamentaryEntitySplitScreenHeader() {
  const { headerRef } = useEditTestamentaryEntitySplitScreenModalContext();

  return <div ref={headerRef} />;
}
